import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption, RadioLayoutType } from '@tableau/widgets';
import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';

import { IUserIdentityConflict, IUserIdentityConflictIdentityData } from '../requests/types/IUserIdentityConflict';

export type ResolveAmbiguousUserIdentityConflictDialogBodyProps = { readonly conflict: IUserIdentityConflict };
export type ResolveAmbiguousUserIdentityConflictDialogBodyState = { readonly dataRecordId: string, readonly selectedIndex: number };
export type PropsForResolveAmbiguousUserIdentityConflictDialogBody = ReactActionDialogBodyProps<ResolveAmbiguousUserIdentityConflictDialogBodyProps, ResolveAmbiguousUserIdentityConflictDialogBodyState>;

export function ResolveAmbiguousUserIdentityConflictDialogBody(props: PropsForResolveAmbiguousUserIdentityConflictDialogBody) {
  return <RadioButtonWithLabelGroupWidget
    buttonList={createButtonList(props.conflict)}
    checkedIndex={props.dialogState.selectedIndex}
    handleChange={(value, newCheckedIndex) => {
      props.updateDialogState({
        dataRecordId: value,
        selectedIndex: newCheckedIndex,
      });
    }}
    label={createLabel(props.conflict)}
    layout={RadioLayoutType.Veritical}
  />;
}

function createLabel(conflict: IUserIdentityConflict) {
  return <h2>
    {Messages.identityMigration_ResolveAmbiguousUserIdentityConflictDialogHeader({
      USER_DISPLAY_NAME: conflict.displayName
    })}
  </h2>;
}

function createButtonList(conflict: IUserIdentityConflict): RadioButtonWithLabelOption<string>[] {
  return conflict.identities.map(createButton);
}

function createButton(conflictData: IUserIdentityConflictIdentityData): RadioButtonWithLabelOption<string> {
  const logonName = conflictData.samaccountName && (conflictData.domainFqdn ?? '.') + '\\' + conflictData.samaccountName;
  return {
    label: <div style={{ marginBottom: '10px'}}>
      {createButtonItem('FQDN\\sAMAccountName', logonName)}
      {createButtonItem('UserPrincipalName (UPN)', conflictData.userPrincipalName)}
      {createButtonItem('Distinguished Name (DN)', conflictData.distinguishedName)}
      {createButtonItem(Messages.displayName(), conflictData.displayName)}
    </div>,
    testId: conflictData.id + '-option',
    value: conflictData.id,
  };
}

function createButtonItem(name: string, value: string) {
  return value && <div>
    <span style={{ width: '160px', display: 'inline-block', fontWeight: 'bold'}}>{name} </span>
    <span> {value} </span>
  </div>;
}
